import { FC, useCallback } from 'react'
import { GrammarFeedback } from '@chegg-wt/core-wa/types'
import {
  activeFeedbackCardIdSelector,
  sentenceOffsetsSelector,
} from '@chegg-wt/core-wa/state/selectors'
import { useDispatch, useSelector } from 'react-redux'
import {
  removePreviousHighlight,
  scrollMarkContentInEditor,
} from '@chegg-wt/core-wa/utils/helpers'
import { setActiveFeedbackCardId } from '@chegg-wt/core-wa/state/actions'
import { useHighlightActiveCard } from '@chegg-wt/core-wa/hooks/useHighlightActiveCard'
import { setNextCardActiveAfterDeleteOrUpdate } from '../utils'
import { handleFeedbackCardDeleteClick } from '../functions'
import { GrammarCardsContainer, GrammarSectionWrapper } from './styled'
import GrammarCard from './GrammarCard/GrammarCard'

type GrammarSectionProps = {
  grammarFeedbacks: GrammarFeedback[]
}

const GrammarSection: FC<GrammarSectionProps> = ({ grammarFeedbacks }) => {
  const dispatch = useDispatch()
  const activeCardId = useSelector(activeFeedbackCardIdSelector)
  const sentenceOffsets = useSelector(sentenceOffsetsSelector)
  const setActiveCard = useCallback(
    (cardId: string) => dispatch(setActiveFeedbackCardId(cardId)),
    [dispatch]
  )
  useHighlightActiveCard({
    activeCardId,
    feedbacks: grammarFeedbacks,
    sentenceOffsets,
    setActiveCard,
  })

  const handleCardClick = (feedbackId: string | null) => {
    if (activeCardId === feedbackId) {
      // Do nothing if current card and previous card are same
      return
    }
    removePreviousHighlight(grammarFeedbacks, activeCardId, sentenceOffsets)
    setActiveCard(feedbackId)
    scrollMarkContentInEditor(feedbackId)
  }

  return (
    <GrammarSectionWrapper>
      {grammarFeedbacks.length > 0 && (
        <GrammarCardsContainer>
          {grammarFeedbacks.map((grammarFeeback, index) => (
            <GrammarCard
              feedback={grammarFeeback}
              key={grammarFeeback.id}
              isExpanded={activeCardId === grammarFeeback.id}
              handleCardToggle={() => handleCardClick(grammarFeeback.id)}
              handleDeleteClick={(isFlagged?: boolean) =>
                handleFeedbackCardDeleteClick(
                  grammarFeeback.id,
                  index,
                  grammarFeedbacks,
                  sentenceOffsets,
                  dispatch,
                  setActiveCard,
                  isFlagged
                )
              }
              setFocus={() => {
                setNextCardActiveAfterDeleteOrUpdate(
                  index,
                  grammarFeedbacks,
                  setActiveCard
                )
              }}
            />
          ))}
        </GrammarCardsContainer>
      )}
    </GrammarSectionWrapper>
  )
}
export default GrammarSection
